module.exports = __webpack_public_path__ + "static/media/ZSBS01.a9495cbd.jpg";